import React from 'react';
import DashboardContainer from 'containers/Dashboard';


const Dashboard = () => {
  return (
    <DashboardContainer />

  );
 
  
};

export default Dashboard;
